<section>
  <div *ngIf="visibleListDetail" class="container-style">
    <div class="row mx-0">
      <div class="row align-items-center mx-0 pb-2">
        <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex gap-2">
          <h6 class="mx-0">Detalle del inventario físico</h6>
          <b>( Listo: {{ countReadyDetails() }} de {{ detailData.totalItems }} => {{ getPercentage() }}% )</b>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end gap-2">
          <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledButton"
            [width]="'7rem'" (onClick)="openArticleSelectionModal()"></app-custom-button>
          <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Artículos'"
            [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
          <app-custom-button [label]="'Conteo 1'" [severity]="'primary'" [disabled]="disabledButton" [width]="'4.6rem'"
            (onClick)="openCountModal(1)"></app-custom-button>
          <app-custom-button [label]="'Conteo 2'" [severity]="'primary'" [disabled]="disabledButton" [width]="'4.6rem'"
            (onClick)="openCountModal(2)"></app-custom-button>
          <app-custom-button [label]="'Conteo 3'" [severity]="'primary'" [disabled]="disabledButton" [width]="'4.6rem'"
            (onClick)="openCountModal(3)"></app-custom-button>
          <app-custom-modal #countModal [label]="countText" [header]="countText" [inputs$]="inputsForCountModal$"
            [children]="registerCountModal" hidden [closable]="false"
            (params)="reloadDetails($event)"></app-custom-modal>
        </div>
      </div>
    </div>
    <app-custom-table [headers]="detailHeader" [data]="detailData" [checkBoxAction]="checkboxActions"
      [disableDoubleClick]="true" [showCheckbox]="!disabledDetail()" [showRecover]="true"
      [clearSelectionTrigger]="clearSelectionTrigger" (onAction)="onAction($event)"
      (onFilterChange)="onFilterChange($event)" (onPageChange)="onPageChange($event)"
      (onRecoverData)="getPhysicalinventoryDetailsForRegisterTable()">
    </app-custom-table>
  </div>
</section>